export default __webpack_public_path__ + "static/media/Charity-hover.6fa9942b.svg";